/** Catalog-matched groups for display; falls back to token `groups` when `matched_groups` is absent. */
export function resolveCatalogGroupsFromVerify(
  matchedGroups: readonly string[] | undefined | null,
  tokenGroups: readonly string[] | undefined | null,
): readonly string[] {
  const matched = (matchedGroups ?? []).map((g) => g.trim()).filter(Boolean);
  if (matched.length > 0) {
    return matched;
  }
  return (tokenGroups ?? []).map((g) => g.trim()).filter(Boolean);
}
